const nameCollator = new Intl.Collator(undefined, { sensitivity: "base", numeric: true });

/** Alphabetical order a person expects: case and accents ignored, "Box 2" before "Box 10". */
export const compareNames = (a: string, b: string) => nameCollator.compare(a, b);

export const sortByName = <T extends { name: string }>(items: readonly T[]): T[] =>
  [...items].sort((a, b) => compareNames(a.name, b.name));

/** Casefolded, accent-stripped and space-collapsed, so "jose  garcia" finds "José García". */
export const foldForSearch = (text: string) =>
  text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim();

export const matchesSearch = (query: string, ...texts: (string | null | undefined)[]) => {
  const folded = foldForSearch(query);
  return !folded || texts.some((text) => text && foldForSearch(text).includes(folded));
};

const SHORT_REF_QUERY = /^[a-z]+_[0-9a-f]{1,8}$/;

/**
 * True when `query` is (the start of) `shortRef`, the id the agent's knowledge base and tool
 * calls use for an entity (`svc_662f757f`) — so a ref copied from a call finds what it names.
 * The prefix and its underscore are required: typing "pro" must not list every `prof_…`.
 */
export const matchesShortRef = (query: string, shortRef: string | null | undefined) => {
  const folded = query.trim().toLowerCase();
  return !!shortRef && SHORT_REF_QUERY.test(folded) && shortRef.startsWith(folded);
};

/** Past 8 options a list is too long to scan, so every picker offers a search box. */
export const needsSearchBox = (optionCount: number) => optionCount > 8;
